<script setup lang="ts">
  import { computed } from 'vue';
  import Loader from './Loader.vue';
  import {
    loaderWrapperAutoHeightClass,
    loaderWrapperClass,
  } from './Loader.css';
  import type { LoaderContainerProps } from './Loader.types';

  const props = defineProps<LoaderContainerProps>();

  const wrapperClasses = computed(() => [
    loaderWrapperClass,
    { [loaderWrapperAutoHeightClass]: props.minWrapper },
  ]);
</script>

<template>
  <div :class="wrapperClasses">
    <Loader
      :id="id"
      :test-id="testId"
      :aria-label="ariaLabel"
      :size="size"
      :announced="announced"
    />
  </div>
</template>
